module.exports = __webpack_public_path__ + "img/perImg2.8d822af5.png";